
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/internal-error",
      function () {
        return require("private-next-pages/internal-error.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/internal-error"])
      });
    }
  